import "./styles.css";
export const DashLayout = (props) => {
  return (
    <div className="container-dash" style={{ placeContent: "flex-end"}}>
      <div className="container-login-dash">
        <div className="wrap-login-dash">{props.children}</div>
      </div>
    </div>
  );
};
